import React, { useState, useEffect, useRef } from "react";
import { MenuItem, Select, CircularProgress, ThemeProvider, FormControl, Tooltip } from "@mui/material";
import { handleDropdownData } from "../../Utils/common";
import { getDropDownMenuProps, getDropDownTheme } from "../CreateForm/DropdownBase/styled";
import "./style.scss"

interface Option {
  label: string;
  value: number;
}
interface InfiniteScrollprops {
  getNextSet: (page: number) => any;
  value: string;
  onChange: (e: string) => void;
  page: number;
  setPage: any;
  hasMore: boolean;
  setHasMore: (e: boolean) => void;
  options: Option[];
  setOptions: any;
  error: boolean
}


const InfiniteScrollSelect: React.FC<InfiniteScrollprops> = ({ getNextSet, value, onChange, page, setPage, hasMore, setHasMore, options, setOptions, error }) => {
  const [loading, setLoading] = useState<boolean>(false); // Loading state

  const dropdownRef = useRef<HTMLDivElement | null>(null); // Reference for dropdown scroll

  const fetchMoreOptions = async () => {
    if (!hasMore || loading) return;
    setLoading(true);
    const res = await getNextSet(page)

    if (res.data.length) {
      const newOptions: Option[] = handleDropdownData(res.data)
      setOptions((prev: Option[]) => [...prev, ...newOptions]);

      setPage((prev: number) => prev + 1);
    }
    if (res.page === res.totalPages) {
      setHasMore(false);
    }
    setLoading(false);

  };

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const target = event.currentTarget;

    const scrollThreshold = 20; // Allows some leeway in detection
    const isBottom =
      target.scrollHeight - target.scrollTop <= target.clientHeight + scrollThreshold;

    if (isBottom && hasMore && !loading) {
      fetchMoreOptions();
    }
  };

  useEffect(() => {
    fetchMoreOptions();
  }, [])

  return (
    <ThemeProvider theme={getDropDownTheme(true)}>
      <FormControl className="single-select-drop-container">
        <Tooltip title={!options?.length ? "No data found" : ""}>
          <Select
            fullWidth
            defaultValue={value}
            className="infinite-select"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            displayEmpty
            error={error}
            MenuProps={{
              PaperProps: {
                style: getDropDownMenuProps().PaperProps.style, // Scrollable menu
                onScroll: handleScroll, // Detect scroll
                ref: dropdownRef, // Ref for manual scroll detection
              },
            }}
          >
            {options?.map((option) => (
              <MenuItem className="infinite-menu" key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
            {loading && (
              <MenuItem disabled>
                <CircularProgress size={20} />
              </MenuItem>
            )}
          </Select>
        </Tooltip>
      </FormControl>
    </ThemeProvider>
  );
};

export default InfiniteScrollSelect;
